// Imports
import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';
import { MobilePageHeader } from './_mobile-header.jsx';
import { HomeTabs } from 'src/modules/home-tabs/jsx/component.jsx';
import { Noticeboard } from '../../noticeboard/jsx/noticeboard.jsx';
import { Calendar } from 'src/modules/calendar/jsx/component.jsx';
import { Schedule } from 'src/modules/schedule/jsx/component.jsx';
import { Tiles } from 'src/modules/content-tiles/jsx/tiles.jsx';
import { HelpfulLinks } from 'src/modules/helpful-links/jsx/component.jsx';
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";


// Stateless components

export function HomePage(props) {

    function renderPageContent(context) {
        
        var viewport = context['viewport'];
        var is_mobile = false;

        if(viewport < 3) {
            is_mobile = true;
        }
        
        return (
            <>
                {is_mobile ? (
                    <div id="main__content" className="main__column">
                        <MobilePageHeader />
                        <div className="page-inner__header">
                            <HelpfulLinks />
                        </div>
                        <HomeTabs />
                        <div className="page-inner__content--light-bg">
                            <ContextualMessage id="content_tiles" />
                            <Tiles />
                        </div>
                    </div>
                ) : (
                    <>
                        
                        <div id="main__content" className="main__column">
                            <h2 className="noticeboard__title">Noticeboard</h2>
                            <HelpfulLinks />
                            <Noticeboard type="partial" />
                            <ContextualMessage id="content_tiles" />
                            <Tiles />
                        </div>
                        <div className="main__aside">
                            <Calendar />
                            <Schedule />
                        </div>
                    </>
                )}
            </>
        );
    }


    //
    // Render
    //

    return (
        <PortalContext.Consumer>
            {renderPageContent}
        </PortalContext.Consumer>
    );

};
